export default __webpack_public_path__ + "static/media/about-us-banner-m.622612ea.webp";